<template>
  <!-- Footer Area  -->

  <div class="footer-area footer-two">
    <div class="container">
      <div
        class="row justify-content-center pt-180 wow fadeInUp animated"
        data-wow-delay="200ms"
      >
        <div class="col-xl-10 text-center">
          <div class="footer-inner">
            <h2 class="text-white">
              Your Partner in Compliance & Financial Growth
            </h2>
          </div>
        </div>
      </div>
      <div class="row mt-60 wow fadeInUp animated" data-wow-delay="400ms">
        <div class="offset-xl-2 col-xl-8">
          <div class="submit-form">
            <form @submit.prevent="handleNewsletterSubmit" id="newsletterForm">
              <div v-if="newsletterMessage" :class="['alert', newsletterMessage.type === 'success' ? 'alert-success' : 'alert-danger']" style="color: white; margin-bottom: 10px;">
                {{ newsletterMessage.text }}
              </div>
              <input 
                type="email" 
                placeholder="Your E-mail" 
                v-model="newsletterEmail"
                required
                maxlength="100"
              />
              <input type="submit" value="Send Request" :disabled="isSubmitting" />
            </form>
          </div>
        </div>
      </div>
      <div class="row mt-60 wow fadeInDown animated" data-wow-delay="600ms">
        <div class="col-md-6 col-12">
          <div class="contact-info">
            <div class="d-flex flex-wrap align-items-center mb-3">
              <h5 class="text-white me-4 mb-2 mb-md-0"><span>Call Us:</span> +971 54 566 8994</h5>
              <h6 class="text-white mb-2 mb-md-0">sales@afinotax.com</h6>
            </div>
            <div class="social-links-wrapper">
              <span class="social-label text-white">Follow us:</span>
              <div class="social-icons-group">
                <a href="https://www.instagram.com/afino.tax?igsh=MTVyaXllOXNvOW92cA%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" class="social-icon-btn" aria-label="Follow us on Instagram">
                  <i class="lab la-instagram"></i>
                </a>
                <a href="https://www.linkedin.com/company/afino-tax-consultant/" target="_blank" rel="noopener noreferrer" class="social-icon-btn" aria-label="Follow us on LinkedIn">
                  <i class="lab la-linkedin"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-12 text-end">
          <div class="footer-menu">
            <ul>
              <li>
                <router-link :to="{ name: 'Home2' }"
                  >Home <span>/</span></router-link
                >
              </li>
              <li>
                <router-link :to="{ name: 'About' }"
                  >About Us <span>/</span></router-link
                >
              </li>
              <li>
                <router-link :to="{ name: 'Services' }"
                  >Services <span>/</span></router-link
                >
              </li>
              <li>
                <router-link :to="{ name: 'FAQ' }"
                  >FAQ<span>/</span></router-link
                >
              </li>
              <li>
                <router-link :to="{ name: 'Contact' }">Contact</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row mt-60">
        <div class="footer-bottom">
          <p class="text-white">
            ©Copyright 2024. All Rights Reserved. Afino Tax Consultants - W8 building, 5th floor, DAFZA, Dubai, U.AE
          </p>
        </div>
      </div>
    </div>
    <div class="developer-credit">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center">
            <p class="developer-text" style="margin: 0; padding: 15px 0;">
              Developed by <a href="https://www.detechlab.com" target="_blank" rel="noopener noreferrer" class="developer-link">DE TECH LAB</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- back to top start -->
  <div class="progress-wrap">
    <svg
      class="progress-circle svg-content"
      width="100%"
      height="100%"
      viewBox="-1 -1 102 102"
    >
      <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
    </svg>
  </div>
</template>

<script>
export default {
  name: "Footer2",
  data() {
    return {
      newsletterEmail: '',
      newsletterMessage: null,
      isSubmitting: false,
    };
  },
  methods: {
    async handleNewsletterSubmit() {
      if (!this.newsletterEmail) {
        this.newsletterMessage = { type: 'error', text: 'Email is required!' };
        return;
      }

      // Email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.newsletterEmail)) {
        this.newsletterMessage = { type: 'error', text: 'Please provide a valid email!' };
        return;
      }

      this.isSubmitting = true;
      this.newsletterMessage = null;

      try {
        let formData = new FormData();
        formData.append("Name", "N/A");
        formData.append("Email", this.newsletterEmail);
        formData.append("Phone", "N/A");
        formData.append("Contact", "N/A");

        const response = await fetch(
          "https://script.google.com/macros/s/AKfycbwC1pfWpoIi9_gRINZA1UEhKMaas9JhlNo5L1q3DVO0ktELh5l-XcFNsQiKLHSjY5nd/exec",
          {
            method: "POST",
            body: formData,
          }
        );

        if (response.status === 200) {
          this.newsletterMessage = { type: 'success', text: 'Subscribed successfully!' };
          this.newsletterEmail = '';
        } else {
          this.newsletterMessage = { type: 'error', text: 'Failed to subscribe. Please try again.' };
        }
      } catch (error) {
        this.newsletterMessage = { type: 'error', text: error?.message || 'An error occurred. Please try again.' };
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>

<style scoped>
.social-links-wrapper {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-top: 15px;
}

.social-label {
  font-size: 16px;
  font-weight: 500;
  white-space: nowrap;
}

.social-icons-group {
  display: flex;
  align-items: center;
  gap: 12px;
}

.social-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  background-color: rgba(255, 255, 255, 0.1);
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  color: #ffffff;
  font-size: 20px;
  text-decoration: none;
  transition: all 0.3s ease;
  cursor: pointer;
}

.social-icon-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.4);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.social-icon-btn i {
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 767px) {
  .social-links-wrapper {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  
  .social-icon-btn {
    width: 38px;
    height: 38px;
    font-size: 18px;
  }
}

.developer-credit {
  background-color: #000000;
  width: 100%;
  padding: 0;
}

.developer-text {
  font-size: 16px;
  color: #d4af37;
  font-weight: 600;
  letter-spacing: 1px;
}

.developer-link {
  color: #d4af37;
  text-decoration: none;
  font-weight: 700;
  position: relative;
  display: inline-block;
  background: linear-gradient(90deg, #d4af37, #ffd700, #d4af37);
  background-size: 200% 100%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: shine 3s infinite;
}

@keyframes shine {
  0% {
    background-position: -200% 0;
  }
  50% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.developer-link:hover {
  text-decoration: underline;
  animation-duration: 1.5s;
}
</style>
